const handleError = (error: unknown, message: string, isDebugMode?: boolean) => {
    console.error(message);

    if (isDebugMode) {
        console.dir(error);
    }
};

export default handleError;
